/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import { Button, Modal } from "react-bootstrap";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Swal from 'sweetalert2';
import { getGetRequestOptions } from "../components/GetToken";
import LogBookEdit from "./LogBookEdit";
import { AppContext } from '../context/AppContext';
import InputMask from 'react-input-mask';
import validationMessage from '../helpers/ValidationErrorMsg';

const customStylesSelect = {
    control: (provided) => ({
        ...provided,
        height: 'calc(1.35em + 1.1rem + 2px)',
        minHeight: '35px'
    }),
    valueContainer: (provided) => ({
        ...provided,
    })
};

const LogBookDayWiseEntry = () => {
    const { jwt } = useContext(AppContext);
    const [businessUnit] = useState(process.env.REACT_APP_EMD_BU_ID);
    const [project, setProject] = useState("");
    const [logDate, setLogDate] = useState("");
    const [allBusinessUnits, setAllBusinessUnits] = useState([]);
    const [logBookData, setLogBookData] = useState([]);
    const [logEditModalShow, setLogEditModalShow] = useState(false);
    const [customCreateModalShow, setCustomCreateModalShow] = useState(false);
    const [logListModalShow, setLogListModalShow] = useState(false);
    const [customEditModalShow, setCustomEditModalShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [logId, setLogId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [equipmentLogs, setEquipmentLogs] = useState([]);
    const [selectedEquipment, setSelectedEquipment] = useState(null);
    const [logsLoading, setLogsLoading] = useState(false);
    const [editingLogFromModal, setEditingLogFromModal] = useState(false);

    // Edit modal state
    const [editLogData, setEditLogData] = useState({
        logBookBusinessUnit: "",
        projectId: "",
        equipment: "",
        operator: "",
        logDate: "",
        startingHrs: "",
        endingHrs: "",
        workSiteName: "",
        workType: "",
        workDetails: "",
        runningHrs: { hrs: "", mins: "", runningHrs: "" },
        breakdownHour: "",
        hourMeterReading: "",
        equipmentStatus: "",
        workTypeList: [],
        workDetailsList: [],
        isMultipleTimeEntries: false,
        timeEntries: [{ startTime: "", endTime: "" }],
        logType: "" // "running" or "breakdown"
    });

    // Create modal state
    const [createLogData, setCreateLogData] = useState({
        logBookBusinessUnit: "",
        projectId: "",
        equipment: "",
        operator: "",
        logDate: "",
        startingHrs: "",
        endingHrs: "",
        workSiteName: "",
        workType: "",
        workDetails: "",
        runningHrs: { hrs: "", mins: "", runningHrs: "" },
        breakdownHour: "",
        hourMeterReading: "",
        equipmentStatus: "",
        workTypeList: [],
        workDetailsList: [],
        isMultipleTimeEntries: false,
        timeEntries: [{ startTime: "", endTime: "" }],
        logType: "running" // default to "running"
    });

    useEffect(() => {
        getAllBu();
    }, []);

    useEffect(() => {
        if (project?.value && logDate) {
            getLogBookData();
        }
    }, [project, logDate]);

    const getAllBu = () => {
        fetch(process.env.REACT_APP_API_URL + "get_business_units", getGetRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                const tempResp = resp.data
                    .map(element => ({
                        ...element,
                        label: element.projectName,
                        value: element.projectId,
                        isdisabled: element.projectName === 'EMD' ? false : true
                    }))
                    .filter(e => e.projectId !== process.env.REACT_APP_EMD_BU_ID);
                setAllBusinessUnits(tempResp);
            })
            .catch((error) => {
                console.log(error, "catch the hoop");
            });
    };

    const handleInputOnChange = (evt) => {
        const { name, value } = evt.target;
        if (name === 'logDate') {
            setLogDate(value);
        }
    };


    const editLogFromModal = (logId) => {
        setLogId(logId);
        setEditingLogFromModal(true);
        fetchLogDetails(logId);
    };

    const createLog = (project, logDate, equipmentId = null) => {
        // Initialize create modal data
        setCreateLogData({
            ...createLogData,
            logBookBusinessUnit: {
                value: project.value,
                label: project.label,
                projectId: project.value
            },
            projectId: project.value,
            equipment: equipmentId && selectedEquipment ? {
                equipmentId: selectedEquipment.equipmentId,
                equipmentName: selectedEquipment.equipmentName,
                equipmentCode: selectedEquipment.equipmentCode,
                value: selectedEquipment.equipmentId,
                label: `${selectedEquipment.equipmentName} (${selectedEquipment.equipmentCode})`
            } : "",
            logDate: logDate,
            logType: "running"
        });

        if (project?.value) {
            getWorkTypeForCreate(project.value);
        }

        setCustomCreateModalShow(true);
    };

    const getWorkTypeForCreate = (projectId) => {
        fetch(process.env.REACT_APP_DASHBOARD_URL + `app/boqItem/task/${projectId}`,
            getGetRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                const tempArray = resp.tasks.map(function (element) {
                    element.label = element.taskName;
                    element.value = element.idDashboardEquipmentMajorTasks;
                    return element;
                });
                setCreateLogData(prev => ({ ...prev, workTypeList: tempArray }));
            })
            .catch((error) => {
                console.log(error, "catch the hoop")
            });
    };

    const getWorkDetailsForCreate = (idDashboardEquipmentMajorTasks) => {
        fetch(process.env.REACT_APP_DASHBOARD_URL + `app/boqItem/${idDashboardEquipmentMajorTasks}`,
            getGetRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                const tempArray = resp.boqItems.map(function (element) {
                    element.label = `${element.description} (${element.boqId})`;
                    element.value = element.idDashboardEquipmentBoqItems;
                    return element;
                });
                setCreateLogData(prev => ({ ...prev, workDetailsList: tempArray }));
            })
            .catch((error) => {
                console.log(error, "catch the hoop")
            });
    };

    const getEquipmentForCreate = (inputValue, callback) => {
        if (!inputValue) {
            callback([]);
        } else {
            var url = process.env.REACT_APP_API_URL + "equipment/received_equipment_search/" + createLogData.projectId + "?q=" + inputValue;

            setTimeout(() => {
                fetch(url, getGetRequestOptions())
                    .then((resp) => resp.json())
                    .then((resp) => {
                        const tempArray = resp.data.map(function (element) {
                            element.label = `${element.equipmentName} (${element.equipmentCode})`;
                            element.value = element.equipmentId;
                            return element;
                        });
                        callback(tempArray);
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop")
                    });
            });
        }
    };

    const getOperatorNameForCreate = (inputValue, callback) => {
        if (!inputValue) {
            callback([]);
        } else {
            var url = process.env.REACT_APP_API_URL + "search_operator?q=" + inputValue;
            setTimeout(() => {
                fetch(url, getGetRequestOptions())
                    .then((resp) => resp.json())
                    .then((resp) => {
                        const tempArray = resp.data.map(function (element) {
                            element.label = `${element.name} (${element.phone})`;
                            element.value = element.id;
                            element.operatorId = element.id;
                            return element;
                        });
                        callback(tempArray);
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop")
                    });
            });
        }
    };

    const handleCreateInputChange = (name, value) => {
        setCreateLogData(prev => ({ ...prev, [name]: value }));
    };

    const handleCreateWorkTypeChange = workType => {
        setCreateLogData(prev => ({
            ...prev,
            workType: workType,
            workDetails: {},
            workDetailsList: []
        }));
        if (workType?.value) {
            getWorkDetailsForCreate(workType.value);
        }
    };

    const handleCreateEquipmentChange = equipment => {
        setCreateLogData(prev => ({
            ...prev,
            equipment: equipment,
            startingHrs: equipment.closingHrsMeter || ""
        }));
    };

    const handleCreateHourChange = (evt) => {
        const value = evt.target.value;
        if (value > 24) return;

        if (createLogData.logType === "running") {
            setCreateLogData(prev => ({
                ...prev,
                runningHrs: {
                    ...prev.runningHrs,
                    hrs: value,
                    runningHrs: `${value.padStart(2, '0')}:${prev.runningHrs.mins ? prev.runningHrs.mins.padStart(2, '0') : '00'}`
                }
            }));
        } else {
            const hrs = value.padStart(2, '0');
            const mins = createLogData.breakdownHour.split(':')[1] || '00';
            setCreateLogData(prev => ({
                ...prev,
                breakdownHour: `${hrs}:${mins}`
            }));
        }
    };

    const handleCreateMinuteChange = (evt) => {
        const value = evt.target.value;
        if (value > 59) return;

        if (createLogData.logType === "running") {
            setCreateLogData(prev => ({
                ...prev,
                runningHrs: {
                    ...prev.runningHrs,
                    mins: value,
                    runningHrs: `${prev.runningHrs.hrs ? prev.runningHrs.hrs.padStart(2, '0') : '00'}:${value.padStart(2, '0')}`
                }
            }));
        } else {
            const hrs = createLogData.breakdownHour.split(':')[0] || '00';
            const mins = value.padStart(2, '0');
            setCreateLogData(prev => ({
                ...prev,
                breakdownHour: `${hrs}:${mins}`
            }));
        }
    };

    const handleCreateSubmit = (evt) => {
        evt.preventDefault();

        const isRunning = createLogData.logType === "running";
        const apiEndpoint = isRunning ? "log_book/running_hour_entry" : "app_breakdown_entry_create";

        let formData;

        if (isRunning) {
            formData = {
                projectId: createLogData.projectId,
                equipment: {
                    equipmentId: createLogData.equipment.equipmentId,
                    equipmentName: createLogData.equipment.equipmentName
                },
                logDate: createLogData.logDate,
                startingHrs: parseFloat(createLogData.startingHrs),
                endingHrs: parseFloat(createLogData.endingHrs),
                workSiteName: createLogData.workSiteName,
                idDashboardEquipmentMajorTasks: createLogData.workType.value,
                idDashboardEquipmentBoqItems: createLogData.workDetails.value,
                operator: createLogData.operator,
                runningHrs: createLogData.runningHrs,
                isMultipleTimeEntries: createLogData.isMultipleTimeEntries,
                timeEntries: createLogData.timeEntries
            };
        } else {
            formData = {
                projectId: createLogData.projectId,
                equipment: {
                    equipmentId: createLogData.equipment.equipmentId,
                    equipmentName: createLogData.equipment.equipmentName
                },
                breakdownDate: createLogData.logDate,
                breakdownHour: createLogData.breakdownHour,
                hourMeterReading: parseFloat(createLogData.hourMeterReading)
            };
        }

        Swal.fire({
            title: 'Are you sure?',
            text: `You want to create this ${isRunning ? 'running' : 'breakdown'} hour entry!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, create it!',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + jwt.token
                    },
                    body: JSON.stringify(formData)
                };

                fetch(process.env.REACT_APP_API_URL + apiEndpoint, requestOptions)
                    .then((resp) => resp.json())
                    .then((resp) => {
                        if (resp.success === true) {
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: resp.successMessage,
                            });

                            setCustomCreateModalShow(false);

                            // Reset form data
                            handleCloseCustomCreateModal();

                            // Refresh data
                            getLogBookData();
                            if (selectedEquipment) {
                                fetchEquipmentLogs(selectedEquipment.equipmentId);
                            }
                        } else {
                            const errorsMessage = validationMessage(resp.errorMessage).join("<br>");
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                html: errorsMessage,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop");
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'An error occurred while creating the entry',
                        });
                    });
            }
        });
    };

    const handleCloseCustomCreateModal = () => {
        setCustomCreateModalShow(false);
        // Reset form data
        setCreateLogData({
            logBookBusinessUnit: "",
            projectId: "",
            equipment: "",
            operator: "",
            logDate: "",
            startingHrs: "",
            endingHrs: "",
            workSiteName: "",
            workType: "",
            workDetails: "",
            runningHrs: { hrs: "", mins: "", runningHrs: "" },
            breakdownHour: "",
            hourMeterReading: "",
            equipmentStatus: "",
            workTypeList: [],
            workDetailsList: [],
            isMultipleTimeEntries: false,
            timeEntries: [{ startTime: "", endTime: "" }],
            logType: "running"
        });
    };

    const showLogList = (equipment) => {
        setSelectedEquipment(equipment);
        setLogListModalShow(true);
        fetchEquipmentLogs(equipment.equipmentId);
    };

    const fetchEquipmentLogs = (equipmentId) => {
        setLogsLoading(true);
        setEquipmentLogs([]);

        fetch(`${process.env.REACT_APP_API_URL}log_book/equipment_logs/${equipmentId}/${logDate}`, {
            ...getGetRequestOptions(),
            headers: {
                ...getGetRequestOptions().headers,
                'Authorization': 'Bearer ' + jwt.token
            }
        })
            .then((resp) => {
                if (!resp.ok) {
                    throw new Error(`HTTP error! status: ${resp.status}`);
                }
                return resp.json();
            })
            .then((resp) => {
                setLogsLoading(false);
                if (resp.success) {
                    setEquipmentLogs(resp.data || []);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: resp.errorMessage || 'Failed to fetch equipment logs'
                    });
                    setEquipmentLogs([]);
                }
            })
            .catch((error) => {
                setLogsLoading(false);
                console.error('Error fetching equipment logs:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch equipment logs. Please try again.'
                });
                setEquipmentLogs([]);
            });
    };

    const fetchLogDetails = (logId) => {
        fetch(`${process.env.REACT_APP_API_URL}log_book/log_details/${logId}`, {
            ...getGetRequestOptions(),
            headers: {
                ...getGetRequestOptions().headers,
                'Authorization': 'Bearer ' + jwt.token
            }
        })
            .then((resp) => {
                if (!resp.ok) {
                    throw new Error(`HTTP error! status: ${resp.status}`);
                }
                return resp.json();
            })
            .then((logData) => {
                if (logData) {
                    // Determine log type based on status
                    const logType = logData.status === "break_down" ? "breakdown" : "running";

                    // Get hours for the specific type
                    let hours = "00:00";
                    if (logType === "running") {
                        hours = logData.runningHours || "00:00";
                    } else if (logType === "breakdown") {
                        hours = logData.breakdownHours || "00:00";
                    }

                    // Split hours into hrs and mins
                    const [hrs, mins] = hours.split(':');

                    setEditLogData({
                        ...editLogData,
                        logId: logData.logId,
                        logBookBusinessUnit: {
                            value: project.value,
                            label: project.label,
                            projectId: project.value
                        },
                        projectId: project.value,
                        equipment: {
                            equipmentId: logData.equipmentId,
                            equipmentName: logData.equipmentName,
                            equipmentCode: logData.maxCode,
                            value: logData.equipmentId,
                            label: `${logData.equipmentName} (${logData.maxCode})`
                        },
                        operator: logData.operatorId ? {
                            value: logData.operatorId,
                            id: logData.operatorId,
                            operatorId: logData.operatorId,
                            name: logData.operatorName,
                            label: logData.operatorName
                        } : "",
                        logDate: logDate,
                        startingHrs: logData.startingHrsMeter || "",
                        endingHrs: logData.closingHrsMeter || "",
                        workSiteName: logData.workSiteName || "",
                        workType: logData.majorTaskId ? {
                            value: logData.majorTaskId,
                            label: logData.majorTaskName,
                            idDashboardEquipmentMajorTasks: logData.majorTaskId,
                            taskName: logData.majorTaskName
                        } : "",
                        workDetails: logData.boqItemId ? {
                            value: logData.boqItemId,
                            label: logData.boqItemDescription,
                            idDashboardEquipmentBoqItems: logData.boqItemId,
                            description: logData.boqItemDescription
                        } : "",
                        logType: logType,
                        runningHrs: {
                            hrs: logType === "running" ? hrs : "",
                            mins: logType === "running" ? mins : "",
                            runningHrs: logType === "running" ? hours : ""
                        },
                        breakdownHour: logType === "breakdown" ? hours : "",
                        hourMeterReading: logData.closingHrsMeter || ""
                    });

                    // Load work type list for this project
                    if (project?.value) {
                        getWorkTypeForEdit(project.value);
                    }

                    // If work type exists, load work details
                    if (logData.majorTaskId) {
                        getWorkDetailsForEdit(logData.majorTaskId);
                    }

                    setCustomEditModalShow(true);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to fetch log details'
                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching log details:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch log details. Please try again.'
                });
            });
    };

    const getWorkTypeForEdit = (projectId) => {
        fetch(process.env.REACT_APP_DASHBOARD_URL + `app/boqItem/task/${projectId}`,
            getGetRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                const tempArray = resp.tasks.map(function (element) {
                    element.label = element.taskName;
                    element.value = element.idDashboardEquipmentMajorTasks;
                    return element;
                });
                setEditLogData(prev => ({ ...prev, workTypeList: tempArray }));
            })
            .catch((error) => {
                console.log(error, "catch the hoop")
            });
    };

    const getWorkDetailsForEdit = (idDashboardEquipmentMajorTasks) => {
        fetch(process.env.REACT_APP_DASHBOARD_URL + `app/boqItem/${idDashboardEquipmentMajorTasks}`,
            getGetRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                const tempArray = resp.boqItems.map(function (element) {
                    element.label = `${element.description} (${element.boqId})`;
                    element.value = element.idDashboardEquipmentBoqItems;
                    return element;
                });
                setEditLogData(prev => ({ ...prev, workDetailsList: tempArray }));
            })
            .catch((error) => {
                console.log(error, "catch the hoop")
            });
    };

    const getOperatorNameForEdit = (inputValue, callback) => {
        if (!inputValue) {
            callback([]);
        } else {
            var url = process.env.REACT_APP_API_URL + "search_operator?q=" + inputValue;
            setTimeout(() => {
                fetch(url, getGetRequestOptions())
                    .then((resp) => resp.json())
                    .then((resp) => {
                        const tempArray = resp.data.map(function (element) {
                            element.label = `${element.name} (${element.phone})`;
                            element.value = element.id;
                            element.operatorId = element.id;
                            return element;
                        });
                        callback(tempArray);
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop")
                    });
            });
        }
    };

    const handleEditInputChange = (name, value) => {
        setEditLogData(prev => ({ ...prev, [name]: value }));
    };

    const handleEditWorkTypeChange = workType => {
        setEditLogData(prev => ({
            ...prev,
            workType: workType,
            workDetails: {},
            workDetailsList: []
        }));
        if (workType?.value) {
            getWorkDetailsForEdit(workType.value);
        }
    };

    const handleEditHourChange = (evt) => {
        const value = evt.target.value;
        if (value > 24) return;

        if (editLogData.logType === "running") {
            setEditLogData(prev => ({
                ...prev,
                runningHrs: {
                    ...prev.runningHrs,
                    hrs: value,
                    runningHrs: `${value.padStart(2, '0')}:${prev.runningHrs.mins ? prev.runningHrs.mins.padStart(2, '0') : '00'}`
                }
            }));
        } else {
            const hrs = value.padStart(2, '0');
            const mins = editLogData.breakdownHour.split(':')[1] || '00';
            setEditLogData(prev => ({
                ...prev,
                breakdownHour: `${hrs}:${mins}`
            }));
        }
    };

    const handleEditMinuteChange = (evt) => {
        const value = evt.target.value;
        if (value > 59) return;

        if (editLogData.logType === "running") {
            setEditLogData(prev => ({
                ...prev,
                runningHrs: {
                    ...prev.runningHrs,
                    mins: value,
                    runningHrs: `${prev.runningHrs.hrs ? prev.runningHrs.hrs.padStart(2, '0') : '00'}:${value.padStart(2, '0')}`
                }
            }));
        } else {
            const hrs = editLogData.breakdownHour.split(':')[0] || '00';
            const mins = value.padStart(2, '0');
            setEditLogData(prev => ({
                ...prev,
                breakdownHour: `${hrs}:${mins}`
            }));
        }
    };

    const handleEditSubmit = (evt) => {
        evt.preventDefault();

        const isRunning = editLogData.logType === "running";
        const apiEndpoint = isRunning ? "log_book/running_hour_entry_update" : "log_book/breakdown_entry_update";

        let formData;

        if (isRunning) {
            formData = {
                logId: editLogData.logId,
                projectId: editLogData.projectId,
                equipment: {
                    equipmentId: selectedEquipment.equipmentId,
                    equipmentName: selectedEquipment.equipmentName
                },
                logDate: editLogData.logDate,
                startingHrs: parseFloat(editLogData.startingHrs),
                endingHrs: parseFloat(editLogData.endingHrs),
                workSiteName: editLogData.workSiteName,
                idDashboardEquipmentMajorTasks: editLogData.workType.value,
                idDashboardEquipmentBoqItems: editLogData.workDetails.value,
                operator: editLogData.operator,
                runningHrs: editLogData.runningHrs,
                isMultipleTimeEntries: editLogData.isMultipleTimeEntries,
                timeEntries: editLogData.timeEntries
            };
        } else {
            formData = {
                logId: editLogData.logId,
                projectId: editLogData.projectId,
                equipment: {
                    equipmentId: selectedEquipment.equipmentId,
                    equipmentName: selectedEquipment.equipmentName
                },
                breakdownDate: editLogData.logDate,
                breakdownHour: editLogData.breakdownHour,
                hourMeterReading: parseFloat(editLogData.hourMeterReading)
            };
        }

        Swal.fire({
            title: 'Are you sure?',
            text: `You want to update this ${isRunning ? 'running' : 'breakdown'} hour entry!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, update it!',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + jwt.token
                    },
                    body: JSON.stringify(formData)
                };

                fetch(process.env.REACT_APP_API_URL + apiEndpoint, requestOptions)
                    .then((resp) => resp.json())
                    .then((resp) => {
                        if (resp.success === true) {
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: resp.successMessage,
                            });

                            setCustomEditModalShow(false);
                            setEditingLogFromModal(false);

                            // Refresh data
                            getLogBookData();
                            if (selectedEquipment) {
                                fetchEquipmentLogs(selectedEquipment.equipmentId);
                            }
                        } else {
                            const errorsMessage = validationMessage(resp.errorMessage).join("<br>");
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                html: errorsMessage,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop");
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'An error occurred while updating the entry',
                        });
                    });
            }
        });
    };

    const handleCloseCustomEditModal = () => {
        setCustomEditModalShow(false);
        setEditingLogFromModal(false);
        // Reset form data
        setEditLogData({
            logBookBusinessUnit: "",
            projectId: "",
            equipment: "",
            operator: "",
            logDate: "",
            startingHrs: "",
            endingHrs: "",
            workSiteName: "",
            workType: "",
            workDetails: "",
            runningHrs: { hrs: "", mins: "", runningHrs: "" },
            breakdownHour: "",
            hourMeterReading: "",
            equipmentStatus: "",
            workTypeList: [],
            workDetailsList: [],
            isMultipleTimeEntries: false,
            timeEntries: [{ startTime: "", endTime: "" }],
            logType: ""
        });
    };

    const approveIndividualLog = (logId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to approve this log entry!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, approve it!',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + jwt.token
                    },
                    body: JSON.stringify({
                        logId: logId
                    })
                };

                fetch(process.env.REACT_APP_API_URL + "log_book/approve_individual_log", requestOptions)
                    .then((resp) => resp.json())
                    .then((resp) => {
                        if (resp.success) {
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: resp.successMessage || 'Log approved successfully!'
                            });

                            // Refresh both the main data and the modal data
                            getLogBookData();
                            if (selectedEquipment) {
                                fetchEquipmentLogs(selectedEquipment.equipmentId);
                            }
                        } else {
                            const errorsMessage = Array.isArray(resp.errorMessage)
                                ? resp.errorMessage.join(', ')
                                : (resp.errorMessage || "Failed to approve log");

                            Swal.fire({
                                icon: 'error',
                                title: resp.heading || 'Error',
                                text: errorsMessage
                            });
                        }
                    })
                    .catch((error) => {
                        console.error('Error approving log:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Failed to approve log. Please try again.'
                        });
                    });
            }
        });
    };

    const deleteIndividualLog = (logId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to delete this log entry! This action cannot be undone.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No',
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6'
        }).then((result) => {
            if (result.value) {
                const requestOptions = {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + jwt.token
                    },
                    body: JSON.stringify({
                        logId: logId
                    })
                };

                fetch(process.env.REACT_APP_API_URL + "log_book/delete_individual_log", requestOptions)
                    .then((resp) => resp.json())
                    .then((resp) => {
                        if (resp.success) {
                            Swal.fire({
                                icon: 'success',
                                title: 'Deleted!',
                                text: resp.successMessage || 'Log deleted successfully!'
                            });

                            // Refresh both the main data and the modal data
                            getLogBookData();
                            if (selectedEquipment) {
                                fetchEquipmentLogs(selectedEquipment.equipmentId);
                            }
                        } else {
                            const errorsMessage = Array.isArray(resp.errorMessage)
                                ? resp.errorMessage.join(', ')
                                : (resp.errorMessage || "Failed to delete log");

                            Swal.fire({
                                icon: 'error',
                                title: resp.heading || 'Error',
                                text: errorsMessage
                            });
                        }
                    })
                    .catch((error) => {
                        console.error('Error deleting log:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Failed to delete log. Please try again.'
                        });
                    });
            }
        });
    };

    const onUpdateLog = (updateData) => {
        setLogEditModalShow(false);
        if (editingLogFromModal) {
            // Refresh both the main data and the modal data
            getLogBookData();
            if (selectedEquipment) {
                fetchEquipmentLogs(selectedEquipment.equipmentId);
            }
            // Keep the log list modal open (don't need to reopen since it never closed)
            setEditingLogFromModal(false);
        } else {
            getLogBookData();
        }
    };

    const handleCloseEditModal = () => {
        setLogEditModalShow(false);
        if (editingLogFromModal) {
            setEditingLogFromModal(false);
        }
    };

    const getLogBookData = () => {
        if (!project?.value || !logDate) {
            console.log('Missing project or logDate');
            return;
        }

        setLoading(true);
        setLogBookData([]);

        fetch(`${process.env.REACT_APP_API_URL}log_book/project_day_wise_equipment_logs/${project.value}/${logDate}`, {
            ...getGetRequestOptions(),
            headers: {
                ...getGetRequestOptions().headers,
                'Authorization': 'Bearer ' + jwt.token
            }
        })
            .then((resp) => {
                if (!resp.ok) {
                    throw new Error(`HTTP error! status: ${resp.status}`);
                }
                return resp.json();
            })
            .then((resp) => {
                setLoading(false);
                if (resp.success) {
                    setLogBookData(resp.data || []);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: resp.heading || 'Error',
                        text: resp.errorMessage || 'Failed to fetch data'
                    });
                    setLogBookData([]);
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error fetching log book data:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch log book data. Please try again.'
                });
                setLogBookData([]);
            });
    };

    const handleSubmit = (evt) => {
        evt.preventDefault();
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to approve all equipment logs!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, approve it!',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                const formData = {
                    businessUnit,
                    project,
                    logDate,
                    logBookData: filteredLogBookData
                };

                fetch(process.env.REACT_APP_API_URL + "log_book/log_entry_approve", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + jwt.token
                    },
                    body: JSON.stringify(formData)
                })
                    .then((resp) => resp.json())
                    .then((resp) => {
                        if (resp.success) {
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: resp.successMessage
                            });
                            // Refresh the data
                            getLogBookData();
                        } else {
                            const errorsMessage = Array.isArray(resp.errorMessage)
                                ? resp.errorMessage.join(', ')
                                : (resp.errorMessage || "Something went wrong");

                            Swal.fire({
                                icon: 'error',
                                title: resp.heading || 'Error',
                                text: errorsMessage
                            });
                        }
                    })
                    .catch((error) => {
                        console.error('Error approving logs:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Failed to approve logs. Please try again.'
                        });
                    });
            }
        });
    };

    const getSummaryData = () => {
        if (!filteredLogBookData || filteredLogBookData.length === 0) return null;

        const totals = filteredLogBookData.reduce((acc, equipment) => {
            const parseTime = (timeStr) => {
                const [hours, minutes] = timeStr.split(':').map(Number);
                return hours * 60 + minutes;
            };

            acc.totalRunning += parseTime(equipment.runningHours);
            acc.totalBreakdown += parseTime(equipment.breakdownHours);
            acc.totalIdle += parseTime(equipment.idleHours);

            return acc;
        }, { totalRunning: 0, totalBreakdown: 0, totalIdle: 0 });

        const formatTime = (totalMinutes) => {
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        };

        return {
            totalRunning: formatTime(totals.totalRunning),
            totalBreakdown: formatTime(totals.totalBreakdown),
            totalIdle: formatTime(totals.totalIdle)
        };
    };

    const filteredLogBookData = logBookData.filter(equipment =>
        equipment.equipmentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        equipment.equipmentCode.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const summaryData = getSummaryData();

    const tableBody = () => {
        if (!filteredLogBookData || filteredLogBookData.length === 0) {
            return (
                <tr>
                    <td colSpan="13" className="text-center">No data available</td>
                </tr>
            );
        }

        return filteredLogBookData.map((equipment, index) => (
            <tr key={equipment.equipmentId}>
                <td>{index + 1}</td>
                <td>{equipment.equipmentName}</td>
                <td>{equipment.equipmentCode}</td>
                <td>{equipment.model || '-'}</td>
                <td>{equipment.operatorName?.trim() || '-'}</td>
                <td>{equipment.startingHrsMeter || '-'}</td>
                <td>{equipment.closingHrsMeter || '-'}</td>
                <td>{equipment.workSiteName || '-'}</td>
                <td>{equipment.majorTaskName || '-'}</td>
                <td className="text-success font-weight-bold">{equipment.runningHours}</td>
                <td className="text-warning font-weight-bold">{equipment.breakdownHours}</td>
                <td className="text-info font-weight-bold">{equipment.idleHours}</td>
                <td>
                    <div className="btn-group" role="group">
                        <Button
                            variant="info"
                            size="sm"
                            onClick={() => showLogList(equipment)}
                            title="View Logs"
                        >
                            <i className="fa fa-list"></i>
                        </Button>

                        <Button
                            variant="success"
                            size="sm"
                            onClick={() => createLog(project, logDate, equipment.equipmentId)}
                            className="ml-1"
                            title="Add Entry"
                        >
                            <i className="fa fa-plus"></i>
                        </Button>
                    </div>
                </td>
            </tr>
        ));
    };

    return (
        <div className="card card-custom">
            <div className="card-header">
                <h3 className="card-title">Log Book Day Wise Entry</h3>
            </div>
            <div className="card-body">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Project</label>
                                <Select
                                    value={project}
                                    onChange={setProject}
                                    options={allBusinessUnits}
                                    isClearable
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="logDate"
                                    value={logDate}
                                    onChange={handleInputOnChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Search Equipment</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by equipment name or code..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    {!loading && logBookData.length > 0 && (
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <small className="text-muted">
                                    Showing {filteredLogBookData.length} of {logBookData.length} equipment
                                </small>
                            </div>
                        </div>
                    )}

                    {loading ? (
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th>SL</th>
                                            <th>Equipment Name</th>
                                            <th>Code</th>
                                            <th>Model</th>
                                            <th>Operator</th>
                                            <th>Starting Hrs</th>
                                            <th>Closing Hrs</th>
                                            <th>Work Site</th>
                                            <th>Major Task</th>
                                            <th className="text-success">Running Hrs</th>
                                            <th className="text-warning">Breakdown Hrs</th>
                                            <th className="text-info">Idle Hrs</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableBody()}
                                        {summaryData && (
                                            <tr className="table-secondary font-weight-bold">
                                                <td colSpan="9" className="text-right">
                                                    <strong>Total Equipment: {filteredLogBookData.length}</strong>
                                                </td>
                                                <td className="text-success">
                                                    <strong>{summaryData.totalRunning}</strong>
                                                </td>
                                                <td className="text-warning">
                                                    <strong>{summaryData.totalBreakdown}</strong>
                                                </td>
                                                <td className="text-info">
                                                    <strong>{summaryData.totalIdle}</strong>
                                                </td>
                                                <td>-</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <div className="card">
                                        <div className="card-body">
                                            <h6 className="card-title">Summary</h6>
                                            {summaryData && (
                                                <div className="row">
                                                    <div className="col-4">
                                                        <div className="text-center">
                                                            <div className="text-success h4">{summaryData.totalRunning}</div>
                                                            <small>Running Hours</small>
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="text-center">
                                                            <div className="text-warning h4">{summaryData.totalBreakdown}</div>
                                                            <small>Breakdown Hours</small>
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="text-center">
                                                            <div className="text-info h4">{summaryData.totalIdle}</div>
                                                            <small>Idle Hours</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    {project && logDate && (
                                        <div className="text-right">
                                            <Button
                                                variant="success"
                                                onClick={() => createLog(project, logDate)}
                                                className="mr-2"
                                            >
                                                <i className="fa fa-plus"></i> Add New Entry
                                            </Button>

                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                </form>
            </div>

            <Modal
                show={logEditModalShow}
                onHide={handleCloseEditModal}
                size="lg"
                style={{ zIndex: editingLogFromModal ? 1060 : 1050 }}
                backdrop={editingLogFromModal ? 'static' : true}
            >
                <LogBookEdit
                    logId={logId}
                    onUpdate={onUpdateLog}
                    onHide={handleCloseEditModal}
                />

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEditModal}>
                        Close
                    </Button>
                </Modal.Footer>

            </Modal>

            <Modal
                show={customCreateModalShow}
                onHide={handleCloseCustomCreateModal}
                size="lg"
                style={{ zIndex: 1060 }}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Create {createLogData.logType === "running" ? "Running Hour" : "Breakdown Hour"} Entry
                        <br />
                        <small className="text-muted">
                            {project?.label} - {logDate}
                        </small>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleCreateSubmit}>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Log Type<span className="text-danger">*</span></label>
                            <div className="col-sm-9">
                                <Select
                                    value={createLogData.logType === "running" ?
                                        { value: "running", label: "Running Hour Entry" } :
                                        { value: "breakdown", label: "Breakdown Hour Entry" }
                                    }
                                    onChange={(option) => handleCreateInputChange('logType', option.value)}
                                    options={[
                                        { value: "running", label: "Running Hour Entry" },
                                        { value: "breakdown", label: "Breakdown Hour Entry" }
                                    ]}
                                    styles={customStylesSelect}
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Equipment<span className="text-danger">*</span></label>
                            <div className="col-sm-9">
                                <AsyncSelect
                                    value={createLogData.equipment}
                                    defaultOptions
                                    loadOptions={getEquipmentForCreate}
                                    placeholder="Select Equipment"
                                    onChange={handleCreateEquipmentChange}
                                    styles={customStylesSelect}
                                />
                            </div>
                        </div>

                        {createLogData.logType === "running" ? (
                            // Running Hour Form Fields
                            <div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Operator<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <AsyncSelect
                                            value={createLogData.operator}
                                            defaultOptions
                                            loadOptions={getOperatorNameForCreate}
                                            placeholder="Select Operator"
                                            onChange={(operator) => handleCreateInputChange('operator', operator)}
                                            styles={customStylesSelect}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Starting Hrs Meter<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={createLogData.startingHrs}
                                            onChange={(e) => handleCreateInputChange('startingHrs', e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Ending Hrs Meter<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={createLogData.endingHrs}
                                            onChange={(e) => handleCreateInputChange('endingHrs', e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Work Site Name<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={createLogData.workSiteName}
                                            onChange={(e) => handleCreateInputChange('workSiteName', e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Work Type<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <Select
                                            value={createLogData.workType}
                                            onChange={handleCreateWorkTypeChange}
                                            placeholder="Select Work Type"
                                            options={createLogData.workTypeList}
                                            styles={customStylesSelect}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Work Details<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <Select
                                            value={createLogData.workDetails}
                                            onChange={(workDetails) => handleCreateInputChange('workDetails', workDetails)}
                                            placeholder="Select Work Details"
                                            options={createLogData.workDetailsList}
                                            styles={customStylesSelect}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Running Hours<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <div className="input-group">
                                            <InputMask
                                                mask="99"
                                                className="form-control"
                                                placeholder="HH"
                                                value={createLogData.runningHrs.hrs}
                                                onChange={handleCreateHourChange}
                                            />
                                            <span className='input-group-text'>:</span>
                                            <InputMask
                                                mask="99"
                                                className="form-control"
                                                placeholder="MM"
                                                value={createLogData.runningHrs.mins}
                                                onChange={handleCreateMinuteChange}
                                            />
                                        </div>
                                        <small className="form-text text-muted">
                                            Enter hours (00-24) and minutes (00-59)
                                        </small>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            // Breakdown Hour Form Fields
                            <div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Breakdown Hours<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <div className="input-group">
                                            <InputMask
                                                mask="99"
                                                className="form-control"
                                                placeholder="HH"
                                                value={createLogData.breakdownHour.split(':')[0] || ''}
                                                onChange={handleCreateHourChange}
                                            />
                                            <span className='input-group-text'>:</span>
                                            <InputMask
                                                mask="99"
                                                className="form-control"
                                                placeholder="MM"
                                                value={createLogData.breakdownHour.split(':')[1] || ''}
                                                onChange={handleCreateMinuteChange}
                                            />
                                        </div>
                                        <small className="form-text text-muted">
                                            Enter hours (00-24) and minutes (00-59)
                                        </small>
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Hours Meter Reading<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={createLogData.hourMeterReading}
                                            onChange={(e) => handleCreateInputChange('hourMeterReading', e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="form-group row">
                            <div className="col-sm-12 text-right">
                                <Button variant="secondary" onClick={handleCloseCustomCreateModal} className="mr-2">
                                    Cancel
                                </Button>
                                <Button type="submit" variant="primary">
                                    Create Entry
                                </Button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <Modal
                show={logListModalShow}
                onHide={() => setLogListModalShow(false)}
                size="xl"
                style={{ zIndex: 1050 }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Equipment Logs - {selectedEquipment?.equipmentName} ({selectedEquipment?.equipmentCode})
                        <br />
                        <small className="text-muted">Date: {logDate}</small>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {logsLoading ? (
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                            <p className="mt-2">Loading equipment logs...</p>
                        </div>
                    ) : (
                        <>
                            {equipmentLogs.length === 0 ? (
                                <div className="text-center">
                                    <p>No logs found for this equipment on the selected date.</p>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>SL</th>
                                                <th>Time Period</th>
                                                <th>Operator</th>
                                                <th>Work Site</th>
                                                <th>Work Type</th>
                                                <th>Work Details</th>
                                                <th>Running Hrs</th>
                                                <th>Breakdown Hrs</th>
                                                <th>Idle Hrs</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {equipmentLogs.map((log, index) => (
                                                <tr key={log.logId || index}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        {log.startTime} - {log.endTime}
                                                    </td>
                                                    <td>{log.operatorName || '-'}</td>
                                                    <td>{log.workSiteName || '-'}</td>
                                                    <td>{log.majorTaskName || '-'}</td>
                                                    <td>{log.workDetails || '-'}</td>
                                                    <td className="text-success">{log.runningHours || '00:00'}</td>
                                                    <td className="text-warning">{log.breakdownHours || '00:00'}</td>
                                                    <td className="text-info">{log.idleHours || '00:00'}</td>
                                                    <td>
                                                        <span className={`badge ${log.isApproved ? 'badge-success' : 'badge-warning'}`}>
                                                            {log.isApproved ? 'Approved' : 'Pending'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {(log.hasApprovePermission && !log.isApproved) && (
                                                            <div className="btn-group" role="group">
                                                                <Button
                                                                    variant="primary"
                                                                    size="sm"
                                                                    onClick={() => editLogFromModal(log.logId)}
                                                                    title="Edit Log"
                                                                    disabled={log.isApproved}
                                                                    className="mr-1"
                                                                >
                                                                    <i className="fa fa-edit"></i>
                                                                </Button>
                                                                <Button
                                                                    variant="success"
                                                                    size="sm"
                                                                    onClick={() => approveIndividualLog(log.logId)}
                                                                    title="Approve Log"
                                                                    disabled={log.isApproved}
                                                                    className="mr-1"
                                                                >
                                                                    <i className="fa fa-check"></i>
                                                                </Button>
                                                                <Button
                                                                    variant="danger"
                                                                    size="sm"
                                                                    onClick={() => deleteIndividualLog(log.logId)}
                                                                    title="Delete Log"
                                                                    disabled={log.isApproved}
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setLogListModalShow(false)}
                    >
                        Close
                    </Button>
                    {selectedEquipment && (
                        <Button
                            variant="success"
                            onClick={() => {
                                setLogListModalShow(false);
                                createLog(project, logDate, selectedEquipment.equipmentId);
                            }}
                        >
                            <i className="fa fa-plus"></i> Add New Entry
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            <Modal
                show={customEditModalShow}
                onHide={handleCloseCustomEditModal}
                size="lg"

                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Edit {editLogData.logType === "running" ? "Running Hour" : "Breakdown Hour"} Entry
                        <br />
                        <small className="text-muted">
                            {selectedEquipment?.equipmentName} ({selectedEquipment?.equipmentCode}) - {logDate}
                        </small>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleEditSubmit}>
                        {editLogData.logType === "running" ? (
                            // Running Hour Form Fields
                            <div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Operator<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <AsyncSelect
                                            value={editLogData.operator}
                                            defaultOptions
                                            loadOptions={getOperatorNameForEdit}
                                            placeholder="Select Operator"
                                            onChange={(operator) => handleEditInputChange('operator', operator)}
                                            styles={customStylesSelect}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Starting Hrs Meter<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={editLogData.startingHrs}
                                            onChange={(e) => handleEditInputChange('startingHrs', e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Ending Hrs Meter<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={editLogData.endingHrs}
                                            onChange={(e) => handleEditInputChange('endingHrs', e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Work Site Name<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editLogData.workSiteName}
                                            onChange={(e) => handleEditInputChange('workSiteName', e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Work Type<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <Select
                                            value={editLogData.workType}
                                            onChange={handleEditWorkTypeChange}
                                            placeholder="Select Work Type"
                                            options={editLogData.workTypeList}
                                            styles={customStylesSelect}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Work Details<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <Select
                                            value={editLogData.workDetails}
                                            onChange={(workDetails) => handleEditInputChange('workDetails', workDetails)}
                                            placeholder="Select Work Details"
                                            options={editLogData.workDetailsList}
                                            styles={customStylesSelect}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Running Hours<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <div className="input-group">
                                            <InputMask
                                                mask="99"
                                                className="form-control"
                                                placeholder="HH"
                                                value={editLogData.runningHrs.hrs}
                                                onChange={handleEditHourChange}
                                            />
                                            <span className='input-group-text'>:</span>
                                            <InputMask
                                                mask="99"
                                                className="form-control"
                                                placeholder="MM"
                                                value={editLogData.runningHrs.mins}
                                                onChange={handleEditMinuteChange}
                                            />
                                        </div>
                                        <small className="form-text text-muted">
                                            Enter hours (00-24) and minutes (00-59)
                                        </small>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            // Breakdown Hour Form Fields
                            <div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Breakdown Hours<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <div className="input-group">
                                            <InputMask
                                                mask="99"
                                                className="form-control"
                                                placeholder="HH"
                                                value={editLogData.breakdownHour.split(':')[0] || ''}
                                                onChange={handleEditHourChange}
                                            />
                                            <span className='input-group-text'>:</span>
                                            <InputMask
                                                mask="99"
                                                className="form-control"
                                                placeholder="MM"
                                                value={editLogData.breakdownHour.split(':')[1] || ''}
                                                onChange={handleEditMinuteChange}
                                            />
                                        </div>
                                        <small className="form-text text-muted">
                                            Enter hours (00-24) and minutes (00-59)
                                        </small>
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Hours Meter Reading<span className="text-danger">*</span></label>
                                    <div className="col-sm-9">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={editLogData.hourMeterReading}
                                            onChange={(e) => handleEditInputChange('hourMeterReading', e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="form-group row">
                            <div className="col-sm-12 text-right">
                                <Button variant="secondary" onClick={handleCloseCustomEditModal} className="mr-2">
                                    Cancel
                                </Button>
                                <Button type="submit" variant="primary">
                                    Update Entry
                                </Button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default LogBookDayWiseEntry;